import { Interface, namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';

namespace('Ofcs.Editor.Item');

export default window.Ofcs.Editor.Item.ContainerItemInterface = new Interface({
    getItems() {},
});
